import {navigateTo} from '@typed-router';
import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware} from '#app';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';
import {resumableStepName} from '../utils/resolveAllowedStep';

export default defineNuxtRouteMiddleware((to) => {
    const advancedSearchStore = useAdvancedSearchStore();
    const {advancedSearch, funnelSteps} = storeToRefs(advancedSearchStore);

    if (!advancedSearch.value) {
        return;
    }

    if (to.name === 's-advanced-briefId') {
        const briefId = to.params.briefId as string;

        const allowedStep = resumableStepName(funnelSteps.value, advancedSearch.value, 'unified');

        return navigateTo(
            {
                name: 's-advanced-briefId-step',
                params: {briefId, step: allowedStep},
                query: {resumeDraft: 'true'},
            },
            {replace: true},
        );
    }
});
